import { type ComponentType, type FC } from "react"

import { toNumberFormat } from "@forento/core/utilities/number"

import { AnalyticsCard, AnalyticsCardHeader } from "./shared"

type Props = {
	icon: ComponentType<{ className?: string }>
	value: number
	unit?: string
	label: string
	gridArea: string
}
const StatCard: FC<Props> = ({ icon, value, unit, label, gridArea }) => (
	<AnalyticsCard gridArea={gridArea} className="flex min-h-36 flex-col justify-between gap-5">
		<AnalyticsCardHeader Icon={icon} title={label} />
		<div className="text-3xl font-extrabold tabular-nums sm:text-4xl">
			{toNumberFormat(Math.round(value * 100) / 100)}
			{unit !== undefined ? ` ${unit}` : ""}
		</div>
	</AnalyticsCard>
)

export default StatCard
